import { createSlice } from "@reduxjs/toolkit";
import globalInitialState from "./initialState";
import GlobalReducer from "./reducers";

const globalSlice = createSlice({
  name: "global",
  initialState: globalInitialState,
  reducers: GlobalReducer,
});

export const { setReferer } = globalSlice.actions;

export default globalSlice.reducer;
